import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "./common/Header";
import Footer from "./common/Footer";
import testimonialstitlebg from "../images/testimonials-title-bg.png";
import testimonialsuser from "../images/testimonialsuser.svg";
import traderegistrationbg from "../images/trade-registration-bg.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { callApi } from "./common/API/Api";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { getBaseUrl } from "./common/BaseUrl";
const About = () => {
  const location = useLocation();
  const base_url = getBaseUrl()
  const canonicalURL = `https://equlix.com${location.pathname}`;
  let base_image_url = process.env.REACT_APP_IMAGE_URL;
function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = e => setMatches(e.matches);
    mql.addEventListener('change', handler);
    setMatches(mql.matches);
    return () => mql.removeEventListener('change', handler);
  }, [query]);
  return matches;
}

  const isDesktop = useMediaQuery('(min-width: 1402px)');
  const wrapperRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [aboutpagedata, setAboutpagedata] = useState();
  useEffect(() => {
    if (!isDesktop) return;
    const handleScroll = () => {
      setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
    };

    const handleResize = () => {
      if (wrapperRef.current) {
        document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      }
    };

    // Initial setup
    if (wrapperRef.current) {
      document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      document.body.style.overflow = "auto";

      wrapperRef.current.style.transition = "transform 0.3s ease-out";
      wrapperRef.current.style.position = "fixed";
      wrapperRef.current.style.top = "0";
      wrapperRef.current.style.left = "0";
      wrapperRef.current.style.width = "100%";
      wrapperRef.current.style.padding = "0";
      wrapperRef.current.style.zIndex = "2";
      wrapperRef.current.style.display = "block";
      wrapperRef.current.style.backfaceVisibility = "hidden";
    }

    // Add scroll and resize listeners
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, wrapperRef?.current?.offsetHeight]);

  // Apply scroll effect to the wrapper
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
    }
  }, [scrollTop]);
  useEffect(() => {
    document.body.style.backgroundColor = "#000000";
    return () => {
      document.body.style = {};
    };
  }, []);

  const settings = {
    centerMode: true,
    slidesToShow: 1,
    autoplay: false,
    centerPadding: "0px",
    autoplaySpeed: 4000,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
        },
      },
    ],
  };
  const aboutpagecontent = useCallback(async ()=>{
 try {
  let langcode = base_url.split("/")[1]
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/get-about-page?lang=${langcode}`,
        "GET"
      );
      if (res?.data?.success) {
        setAboutpagedata(res?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  },[base_url])
 
  useEffect(() => {
    aboutpagecontent();
  }, [aboutpagecontent]);

  return (
    <div className="home">
        <Helmet>
      <title>{aboutpagedata?.meta?.meta_title || "Equlix"}</title>

      <meta
        name="description"
        content={aboutpagedata?.meta?.meta_description || "About Equlix"}
      />
      <meta
        name="keywords"
        content={aboutpagedata?.meta?.meta_keywords || "Equlix Trading Platform"}
      />
         <link rel="canonical" href={canonicalURL} />
    </Helmet>
      <div className="main-page" ref={wrapperRef}>
        <Header />
        <section class="policyConditions pb-0">
          <div class="container topBorder">
            <div class="row">
              <div class="col-xl-5 col-md-5 col-sm-12">
                <div class="sec_title text-left">
                  <h2 class="block_title">
                    {aboutpagedata?.bannerSection?.title?.title}
                  </h2>
                  <p>
                    {
                      aboutpagedata?.bannerSection?.description
                        ?.description_first
                    }
                  </p>
                  <p>
                    {" "}
                    {
                      aboutpagedata?.bannerSection?.description
                        ?.description_second
                    }
                  </p>
                </div>
              </div>
              <div class="col-xl-7 col-md-7 col-sm-12">
                <img
                  src={
                    base_image_url +
                    aboutpagedata?.bannerSection?.content?.image
                  }
                  class="chart-mission-img"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>
        {/* What is Equlix? start  */}
        <section class="whatEqulix_Sec secPadding">
          <div class="container">
            <div class="row">
              <div class="col-xl-12">
                <div class="sec_title text-center">
                  <h2 class="block_title">
                    {aboutpagedata?.whyChooseSection[0]?.title?.title}
                  </h2>
                  <p>
                    {aboutpagedata?.whyChooseSection[0]?.subtitle?.description}
                  </p>
                </div>
              </div>
            </div>
            <div class="row bgColorbefore">
              <div class="col-lg-3 col-md-6 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="ourPlatform_box_inner">
                    <div>
                      <h5>
                        {aboutpagedata?.whyChooseSection[0]?.content?.value}
                      </h5>
                      <p>
                        {aboutpagedata?.whyChooseSection[0]?.content?.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="ourPlatform_box_inner">
                    <div>
                      <h5>
                        {aboutpagedata?.whyChooseSection[1]?.content?.value}
                      </h5>
                      <p>
                        {aboutpagedata?.whyChooseSection[1]?.content?.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="ourPlatform_box_inner">
                    <div>
                      <h5>
                        {aboutpagedata?.whyChooseSection[2]?.content?.value}
                      </h5>
                      <p>
                        {aboutpagedata?.whyChooseSection[2]?.content?.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="ourPlatform_box_inner">
                    <div>
                      <h5>
                        {aboutpagedata?.whyChooseSection[3]?.content?.value}
                      </h5>
                      <p>
                        {aboutpagedata?.whyChooseSection[3]?.content?.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* What is Equlix? end */}
        {/* ourPlatform start */}
        <section class="ourPlatform_Sec secPadding pb-0 our_values_sec">
          <div class="container topBorder">
            <div class="row">
              <div class="col-xl-12">
                <div class="sec_title text-left">
                  <h2 class="block_title">
                    {aboutpagedata?.coreValuesSection[0]?.title?.title}
                  </h2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="inner_box">
                    <div>
                      <figure>
                        <img
                          src={
                            base_image_url +
                            aboutpagedata?.coreValuesSection[0]?.content?.icon
                          }
                          alt="Our Platform Icon"
                        />
                      </figure>
                      <h5>
                        {aboutpagedata?.coreValuesSection[0]?.content?.title}
                      </h5>
                      <p>
                        {
                          aboutpagedata?.coreValuesSection[0]?.content
                            ?.description
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="inner_box">
                    <div>
                      <figure>
                        <img
                          src={
                            base_image_url +
                            aboutpagedata?.coreValuesSection[1]?.content?.icon
                          }
                          alt="Our Platform Icon"
                        />
                      </figure>
                      <h5>
                        {aboutpagedata?.coreValuesSection[1]?.content?.title}
                      </h5>
                      <p>
                        {
                          aboutpagedata?.coreValuesSection[1]?.content
                            ?.description
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="inner_box">
                    <div>
                      <figure>
                        <img
                          src={
                            base_image_url +
                            aboutpagedata?.coreValuesSection[2]?.content?.icon
                          }
                          alt="Our Platform Icon"
                        />
                      </figure>
                      <h5>
                        {aboutpagedata?.coreValuesSection[2]?.content?.title}
                      </h5>
                      <p>
                        {
                          aboutpagedata?.coreValuesSection[2]?.content
                            ?.description
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="inner_box">
                    <div>
                      <figure>
                        <img
                          src={
                            base_image_url +
                            aboutpagedata?.coreValuesSection[3]?.content?.icon
                          }
                          alt="Our Platform Icon"
                        />
                      </figure>
                      <h5>
                        {aboutpagedata?.coreValuesSection[3]?.content?.title}
                      </h5>
                      <p>
                        {
                          aboutpagedata?.coreValuesSection[3]?.content
                            ?.description
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="inner_box">
                    <div>
                      <figure>
                        <img
                          src={
                            base_image_url +
                            aboutpagedata?.coreValuesSection[4]?.content?.icon
                          }
                          alt="Our Platform Icon"
                        />
                      </figure>
                      <h5>
                        {aboutpagedata?.coreValuesSection[4]?.content?.title}
                      </h5>
                      <p>
                        {
                          aboutpagedata?.coreValuesSection[4]?.content
                            ?.description
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div class="ourPlatform_box">
                  <div class="inner_box">
                    <div>
                      <figure>
                        <img
                          src={
                            base_image_url +
                            aboutpagedata?.coreValuesSection[5]?.content?.icon
                          }
                          alt="Our Platform Icon"
                        />
                      </figure>
                      <h5>
                        {aboutpagedata?.coreValuesSection[5]?.content?.title}
                      </h5>
                      <p>
                        {
                          aboutpagedata?.coreValuesSection[5]?.content
                            ?.description
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ourPlatform end  */}
        <section
          class="trade_demo_sec"
          style={{ backgroundImage: `url(${traderegistrationbg})` }}
        >
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-xl-7 col-md-7">
                <div class="sec_title text-center">
                  <h2 class="block_title">
                    {aboutpagedata?.joinUsSection?.title?.title}
                  </h2>
                  <p>{aboutpagedata?.joinUsSection?.subtitle?.description}</p>
                </div>

                <div class="button_group">
                  <Link
                    class="btn site_grdbtn"
                    to={aboutpagedata?.joinUsSection?.content?.link}
                  >
                    {aboutpagedata?.joinUsSection?.content?.button}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* What people say about us start */}
        <section class="testimonialsSec">
          <div class="container">
            <div class="row position-relative align-items-center">
              <div class="col-lg-5 col-md-5 col-sm-12">
                <div class="sec_title">
                  <img src={testimonialstitlebg} class="bgimg" alt=""/>
                  <h2 class="block_title">What people say about us</h2>
                </div>
              </div>
              <div class="col-lg-7 col-md-7 col-sm-12">
                <div class="testimonials_slider">
                  {/* <div class="testimonials_slick_slider"> */}
                  <Slider {...settings} className="testimonials_slick_slider">
                    <div class="slider_item">
                      <div class="testimonials_box">
                        <div class="testimonials_inner">
                          <div class="testimonials_dt">
                            <div class="dtone">
                              <img src={testimonialsuser} alt=""/>
                              <h5 class="testnamepos">
                                Sarah L <small>London, UK</small>
                              </h5>
                            </div>
                            <div class="star_ret">
                              <i class="fa-solid fa-star"></i>
                              <i class="fa-solid fa-star"></i>
                              <i class="fa-solid fa-star"></i>
                              <i class="fa-solid fa-star"></i>
                              <i class="fa-solid fa-star"></i>
                              {/* <i class="fa-regular fa-star"></i>   */}
                            </div>
                          </div>
                          <p>
                            I've been able to make smarter trades thanks to the
                            advanced tools Equlix offers. The mobile app is also
                            a game-changer for trading on the go.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="slider_item">
                      <div class="testimonials_box">
                        <div class="testimonials_inner">
                          <div class="testimonials_dt">
                            <div class="dtone">
                              <img src={testimonialsuser} alt=""/>
                              <h5 class="testnamepos">
                                Sarah L <small>London, UK</small>
                              </h5>
                            </div>
                            <div class="star_ret">
                              <i class="fa-solid fa-star"></i>
                              <i class="fa-solid fa-star"></i>
                              <i class="fa-solid fa-star"></i>
                              <i class="fa-solid fa-star"></i>
                              <i class="fa-solid fa-star"></i>
                            </div>
                          </div>
                          <p>
                            I've been able to make smarter trades thanks to the
                            advanced tools Equlix offers. The mobile app is also
                            a game-changer for trading on the go.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </section>
        {/* What people say about us end */}
        <Footer />
      </div>
    </div>
  );
};

export default About;
